export default __webpack_public_path__ + "static/media/reviewIcon.89293063.svg";